<div class="row">
  <div class="col-sm-12">
    <section class="panel">
      <app-page-title title="Edit IncomeCategory" [loading]="isLoading"></app-page-title>

      <div class="panel-body">
        <form class="form-horizontal" (ngSubmit)="edit()" ngNativeValidate>
          <app-income-category-form [incomeCategory]="incomeCategory" *ngIf="incomeCategory"></app-income-category-form>
        </form>
      </div>
    </section>
  </div>
</div>
